import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from './MapMarker';
import { useHandleBounds } from './mapHelper';
import { withinBounds } from '../components/mapHelper';

const MapWithMarkers = (props) => {
  const { listings, updateFilter, listingFilter } = props;

  const [fitBounds, setFitBounds] = useState(false);
  const [activeListing, setActiveListing] = useState(null);

  const [api, setApi] = useState({
    loaded: false,
    googlemaps: null,
    map: null,
  });

  const [center, setCenter, zoom, setZoom, updateBounds] = useHandleBounds();
  const mapRef = useRef(null);

  useEffect(() => {
     if (!listings || !center) return;
  }, [center, listings]);

  // Update bounds
  useEffect(() => {
    if (!listings || listings.length === 0) return;
    if (mapRef && mapRef.current.maps_ !== null && !fitBounds) {
      updateBounds(listings, mapRef.current.maps_, mapRef.current.map_);
    }
    setFitBounds(false);
  }, [listings, api.loaded]);

  const onAPiLoaded = (map, googlemaps) => {
    setApi({ loaded: true, googlemaps, map });
  };

  const boundsAreDifferent = (b1, b2) => {
    const c1 = [b1.sw.lng, b1.ne.lat, b1.sw.lng, b1.ne.lat];
    const c2 = [b2.sw.lng, b2.ne.lat, b2.sw.lng, b2.ne.lat];
    return c1.some((c, i) => parseFloat(c) !== parseFloat(c2[i]));
  };

  const activeAndCenter = (lat, lng, mlsNumber) => {
    setCenter({ lat, lng });
    setActiveListing(mlsNumber);
    setZoom(12);
  };

  const getBounds = (p) => {
    if (listingFilter['mapCoordinates']) {
      return listingFilter['mapCoordinates'];
    }

    return {
      sw: { lat: '34.90253098954486', lng: '-90.43729390492535' },
      ne: { lat: '35.39032338025625', lng: '-89.26065817950166' },
    };
  };

  const handleMapChange = (options) => {

    const { sw, ne } = getBounds();
    const { bounds, center, zoom, marginBounds, size } = options;

    // if(listingFilter.loc){
    //   updateFilter({loc: ''}, true);
    //   var clean_uri = window.location.protocol + "//" + window.location.host + window.location.pathname;
    //   window.history.replaceState({}, document.title, clean_uri);
    // }
    // else if (!listingFilter.searchLoc){

    // if (boundsAreDifferent({ sw, ne }, bounds) && !listingFilter.loc) {
    //   updateFilter({
    //     'mapCoordinates.NE': `${bounds.ne.lat},${bounds.ne.lng}`,
    //     'mapCoordinates.SW': `${bounds.sw.lat},${bounds.sw.lng}`,
    //   });
    // }
  //}
  };

  const onDragMapEnd = (options) => {
const isNotFiltered = (!listingFilter.city || listingFilter.city == '')
  && (!listingFilter.searchStr || listingFilter.searchStr == '')
  && (!listingFilter.zipCode || listingFilter.zipCode == '');
if (isNotFiltered) {
  // updateFilter({
  //   'mapCoordinates.NE': `${bounds.ne.lat},${bounds.ne.lng}`,
  //   'mapCoordinates.SW': `${bounds.sw.lat},${bounds.sw.lng}`,
  //   'mapCoordinates': bounds
  // });
  if (listingFilter.loc) {
    updateFilter({
      loc: ''
    }, true);
    const clean_uri = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    window.history.replaceState({}, document.title, clean_uri);
  }
  const bounds = mapRef.current.geoService_.getBounds();
  const coordinates = {
    nw: {
      lat: bounds[0],
      lng: bounds[1],
    },
    se: {
      lat: bounds[2],
      lng: bounds[3],
    },
    sw: {
      lat: bounds[4],
      lng: bounds[5],
    },
    ne: {
      lat: bounds[6],
      lng: bounds[7],
    }
  };
  updateFilter({
    'mapCoordinates.NE': `${coordinates.ne.lat},${coordinates.ne.lng}`,
    'mapCoordinates.SW': `${coordinates.sw.lat},${coordinates.sw.lng}`,
    'searchStr': ''
  });
  setFitBounds(true);
}

  };

  const setActive = (lat, lng, mlsNumber) => {
    setActiveListing(mlsNumber);
  };


  if (listings) {

    return (
      <GoogleMapReact
        ref={mapRef}
        bootstrapURLKeys={{
          key: 'AIzaSyA9ogYFsJGF6QG9Sm7YK7jMBbgoB-Kw3PM',
          libraries: 'places',
        }}
        defaultCenter={{ lat: 35.072872, lng: -89.8469893 }}
        defaultZoom={10}
        center={center}
        zoom={zoom}
        onDragEnd={onDragMapEnd}
        onChange={handleMapChange}
        onChildClick={(key, { lng, lat, mlsNumber }) => {
          activeAndCenter(lat, lng, mlsNumber);
        }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map: apiMap, maps: googleMaps }) => onAPiLoaded(apiMap, googleMaps)}
      >
        {
          listings.filter((x) => x.geoCode && withinBounds(x.geoCode)).map((listing, i) => (
          <MapMarker
            lat={listing.geoCode.latitude}
            lng={listing.geoCode.longitude}
            key={i}
            mlsNumber={listing.mlsNumber}
            listing={listing}
            text="My Marker"
            active={listing.mlsNumber === activeListing}
            handleMarkerClick={(mlsNumber) => console.log(mlsNumber)}
            setActive={setActive}
          />
        ))}
      </GoogleMapReact>
    );
  }
  return <div>zero state</div>;
};

export default MapWithMarkers;
